import { type FC } from 'react';

import styles from './styles.module.scss';
import TranscriptError from './error';
import TranscriptLoader from './loader';
import TranscriptList from './list';

import type { TranscriptItem } from 'infrastructure/hooks/calls/use-get-call-transcribe/types';

interface TranscriptProps {
  transcripts?: TranscriptItem[] | null;
  transcriptsLoading: boolean;
  callTranscribeErrorMessage?: string;
  currentTimeSeconds: number;
  setCurrentTimeSeconds: (time: number) => void;
}

const Transcript: FC<TranscriptProps> = ({
  transcripts,
  transcriptsLoading,
  callTranscribeErrorMessage,
  currentTimeSeconds,
  setCurrentTimeSeconds,
}) => {
  return (
    <div className={styles['transcript-container']}>
      <TranscriptLoader isLoading={transcriptsLoading} />
      <TranscriptError message={callTranscribeErrorMessage} />
      <TranscriptList
        transcripts={transcripts}
        currentTimeSeconds={currentTimeSeconds}
        setCurrentTimeSeconds={setCurrentTimeSeconds}
      />
    </div>
  );
};

export default Transcript;
